import React, { useContext, useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";

import Login from "./Components/Login/Login";
import ForgetPassword from "./Components/Login/LoginPage/ForgetPassword";

// Dashboard

import Dashboard from "./Components/DashBoard/DashBoard";
import Sidebar from "./Components/Sidebar/Sidebar";
import Header from "./Components/Header/Header";
import AdvanceDashboard from "./Components/DashBoard/AdvanceDashboard/AdvanceDashboard2";
import { Context } from "./utils/context";
import VenderManagement from "./Components/VendorManagement/MainTable";
import Profile from "./Components/profile/Profile";

import Role from "./Components/EmployeeManagement/Role/Table";
import EmployeeDetails from "./Components/EmployeeManagement/EmployeeDetails/Table";
import Employee from "./Components/EmployeeManagement/Employee/Tables";

import Ratings from "./Components/Design/Ratings/Tables";
import OfferedDesign from "./Components/Design/Offered_Design/Tables";
import TheEssence from "./Components/AboutUs/TheEssence/Tables";

// import Orders from "./Components/OrderManagments/Orders/Table";
// import CancelOrders from "./Components/OrderManagments/CancelOrders/Table";
// import OrdersToRefund from "./Components/OrderManagments/OrderToRefund/Table";
// import ReturnOrders from "./Components/OrderManagments/ReturnOrders/Table";
// import SingleOrder from "./Components/OrderManagments/singleOrder/Table";

// Settings

import Homebanner from "./Components/settings/HomeBanner/Tables";
import Storebanner from "./Components/settings/StoreBanner/Tables";
import AdvertisementBanner from "./Components/settings/AdvertismentBanner/Tables";
import FaqCategory from "./Components/settings/FaqCategory/Tables";
import Faqs from "./Components/settings/Faq/Tables";
import AboutUs from "./Components/settings/AboutUs/Tables";
import TermsAndCondition from "./Components/settings/TermsAndConditions/Tables";
import PrivacyPolicy from "./Components/settings/PrivacyPolicy/Tables";
import Help from "./Components/settings/Help/Tables";
import SocialLink from "./Components/settings/SocialLinks/Tables";
import AppSetup from "./Components/settings/AppSetup/Tables";
import AppSetup_edit from "./Components/settings/AppSetup/Edit";
import HomeWatchAndShop from "./Components/settings/HomeWatchAndShop/Tables";

// Categories
import Category from "./Components/Design/Category/Tables";
import SubCategory from "./Components/Design/Sub_Category/Tables";
import AlterationSubCategory from "./Components/Design/Alteration_Sub_Category/Tables";
import ChildCategory from "./Components/Design/Child_Category/Tables";
import Design from "./Components/Design/Design/Table";
import DesignCreate from "./Components/Design/Design/Create/Create";
import DesignEdit from "./Components/Design/Design/Edit/Edit";

import VendorDesignEdit from "./Components/VendorDesignManagement/SuggestedDesign/Edit/Edit";
import DesignRequest from "./Components/Design/DesignRequests/Table";
import DesignRequestAdd from "./Components/Design/DesignRequests/Create/Create";
import DesignRequestEdit from "./Components/Design/DesignRequests/Edit/Edit";
import RatingReview from "./Components/Design/Ratings/Tables";

import Customers from "./Components/Customers/Customers/Tables";
import Customers_view from "./Components/Customers/Customers/Edit";

import ExpertManagement from "./Components/ExpertManagement/Expert/Tables";

// import FoodCategory from "./Components/Foods/Food_Category/Tables";
// import FoodSubCategory from "./Components/Foods/Food_Sub_Category/Tables";
// import FoodChildCategory from "./Components/Foods/Food_Child_Category/Tables";
// import Foods from "./Components/Foods/Foods/Table";

// import Transactions from "./Components/reports/Transactions/Tables";

import Brands from "./Components/Masters/Brands/Tables";
import PaymentType from "./Components/Masters/PaymentType/Tables";
import Units from "./Components/Masters/Units/Tables";

import Review_Reason from "./Components/Masters/reviewreason/Tables";

import Coupon from "./Components/Masters/Coupons/Tables";
import Coupon_edit from "./Components/Masters/Coupons/Edit";
import MyWallet from "./Components/wallet/wallet/Tables";
import WithdrawRequest from "./Components/wallet/WithdrawRequest/Tables";

import CancelReason from "./Components/Masters/CancelReasons/Tables";
import ReturnReason from "./Components/Masters/ReturnReasons/Tables";
import RejectReasons from "./Components/Masters/RejectedReasons/Tables";

// Location
import Country from "./Components/Masters/Country/Tables";
import State from "./Components/Masters/State/Tables";
import City from "./Components/Masters/City/Tables";
import Pincode from "./Components/Masters/Pincode/Tables";

import CountryCode from "./Components/Masters/CountryCodes/Tables";

import { IDS } from "./utils/common";
import PageNotFound from "../src/Components/PageNotFound/PageNotFound";
// import Schedule_Pickup from "./Components/OrderManagments/Orders/Schedule_Pickup/Schedule_Pickup";

// import Design_Orders from "./Components/Orders/design_order/Table";
// import SchedulePickup from "./Components/Orders/design_order/Schedule_Pickup/Schedule_Pickup";
import { getData } from "./utils/api";

import Orders_Table from "./Components/Orders/Orders_Table/Table";
import TimeSlot from "./Components/Masters/TimeSlot/Tables";
// import PurchaseDesign from "./";
import PurchaseDesign from "./Components/PurchaseOrder/PurchaseOrder/Tables";
import PurchaseDesign_edit from "./Components/PurchaseOrder/PurchaseOrder/Edit";
import PurchaseDesign_compare from "./Components/PurchaseOrder/PurchaseOrder/EditReceiving";

import ReceivingOrder from "./Components/PurchaseOrder/ReceivingOrder/Tables";
import ReceivingOrder_edit from "./Components/PurchaseOrder/ReceivingOrder/Edit";

import Supplier from "./Components/PurchaseOrder/Supplier/Tables";

import DeliveryRange from "./Components/Masters/DeliveryRange/Edit";
import AboutUsContent from "./Components/AboutUs/AboutUsContent/Tables";
import Founding_Farmers from "./Components/AboutUs/FoundingFarmersContent/Tables";
import Achievement from "./Components/AboutUs/Achievements/Tables";

import Blog from "./Components/Blog/Blog/Tables";

import ContactUsForm from "./Components/ContactUsForm/ContactUsForm/Tables";
import VendorEnquiry from "./Components/VendorEnquiry/vendorEnquiry/Tables";

import Shape from "./Components/Masters/Shape/Tables";

import Size from "./Components/Masters/Size/Tables";
import Issue_Types from "./Components/Masters/Issue_Types/Tables";
import Diamond from "./Components/Masters/Diamond/Tables";
import Metal from "./Components/Masters/Metal/Tables";
import Exchange_Rate from "./Components/Masters/Exchange_Rate/Tables";
import Customer_Love from "./Components/Masters/Customer_Love/Tables";

import HowWeWork from "./Components/AboutUs/HowWeWork/Tables";
import WhyChooseUs from "./Components/AboutUs/WhyChooseUs/Tables";
import Counter from "./Components/AboutUs/Counter/Tables";
import CustomerFeedback from "./Components/AboutUs/Customer_Feedback/Tables";
import ReturnPolicy from "./Components/settings/ReturnPolicy/Tables";
import Community_Gallery from "./Components/Masters/Community_Gallery/Tables";
import Service_Radius from "./Components/Masters/ServiceRadius/Tables";
import Suitable from "./Components/Masters/Suitable/Tables";
import Fabric from "./Components/Masters/Fabric/Tables";
import Occassion from "./Components/Masters/Occassion/Tables";
import SuggestedDesign from "./Components/VendorDesignManagement/SuggestedDesign/Table";
import SuggestedDesignCreate from "./Components/VendorDesignManagement/SuggestedDesign/Create/Create";
import SuggestedDesignEdit from "./Components/VendorDesignManagement/SuggestedDesign/Edit/Edit";

import MeasurementCategory from "./Components/Measurement/Measurement_Category/Tables";
import MeasurementField from "./Components/Measurement/Measurement_Field/Tables";

import Alteration_Type from "./Components/Masters/Alteration_Type/Tables";
import VendorAlteration from "./Components/VendorAlterationManagement/AlterationManagement/Table";

import Express_Delivery from "./Components/Masters/Express_Delivery/Tables";
import UserCustomization from "./Components/Design/DesignRequests/Table";
import Vehicle from "./Components/Masters/Vehicle/Tables";
import Area from "./Components/Masters/Area/Tables";
import Change_Slot from "./Components/Masters/Change_Slot/Tables";
import Spotlight_Type from "./Components/Vendor_Spotlight/Spotlight_Type/Tables";
import Vendor_Spotlight from "./Components/Vendor_Spotlight/VendorSpotlight/Tables";

import Refer_History from "./Components/Refer_History/Refer_History/Tables";

// Seller

const App = () => {
  const location = useLocation();
  const { isSidebarOpen, isAllow, signin } = useContext(Context);
  const [headerText, setHeaderText] = useState(location.pathname);

  const isLoginPage = location.pathname === "/";
  const isForgetPassword = location.pathname === "/forget-password";

  useEffect(() => {
    setHeaderText(location.pathname);
  });

  const [urls, setUrls] = useState([]);
  useEffect(() => {
    setUrls([
      {
        path: "/",
        element: <Login />,
        status: true,
      },
      {
        path: "/forget-password",
        element: <ForgetPassword />,
        status: true,
      },
      {
        path: "/Header",
        element: <Header />,
        status: true,
      },
      {
        path: "/dashboard",
        element: <Dashboard />,
        status: true,
      },
      {
        path: "/advanceDashboard",
        element: <AdvanceDashboard />,
        status: true,
      },

      {
        path: "/employee/role",
        element: <Role />,
        status: isAllow?.includes(IDS.Role.List),
      },
      {
        path: "/profile",
        element: <Profile />,
        status: true,
      },

      {
        path: "/vendor-detail",
        element: <VenderManagement />,
        status: true,
      },
      {
        path: "/user-customization",
        element: <UserCustomization />,
        status: true,
      },
      {
        path: "/suggested-designs",
        element: <SuggestedDesign />,
        status: true,
      },
      {
        path: "/suggested-designs/create",
        element: <SuggestedDesignCreate />,
        status: true,
      },
      {
        path: "/suggested-designs/edit/:id",
        element: <SuggestedDesignEdit />,
        status: true,
      },
      {
        path: "/suggested-designs/:id",
        element: <SuggestedDesign />,
        status: true,
      },

      {
        path: "/alteration",
        element: <VendorAlteration />,
        status: true,
      },

      {
        path: "/spotlight-type",
        element: <Spotlight_Type />,
        status: true,
      },

      {
        path: "/spotlight",
        element: <Vendor_Spotlight />,
        status: true,
      },
      {
        path: "/employee/employee-detail",
        element: <Employee />,
        status: isAllow?.includes(IDS.User.List),
      },

      // {
      //   path: "/order-managements/orders",
      //   element: <Orders />,
      //   status: true,
      // },
      // {
      //   path: "/order-managements/single-order/:id",
      //   element: <SingleOrder />,
      //   status: true,
      // },
      // {
      //   path: "/order-managements/cancel-orders",
      //   element: <CancelOrders />,
      // },
      // {
      //   path: "/order-managements/order/refund",
      //   element: <OrdersToRefund />,
      //   status: true,
      // },
      // {
      //   path: "/order-managements/order/return",
      //   element: <ReturnOrders />,
      // },

      // {
      //   path: "/order-managements/order/schedule-pickup/:id",
      //   element: <Schedule_Pickup />,
      //   status: true,
      // },
      {
        path: "/design/category",
        element: <Category />,
        status: isAllow?.includes(IDS.DesignCategory.List),
      },
      {
        path: "/design/sub-category",
        element: <SubCategory />,
        status: isAllow?.includes(IDS.DesignSubCategory.List),
      },
      {
        path: "/design/alteration-sub-category",
        element: <AlterationSubCategory />,
        status: isAllow?.includes(IDS.DesignSubCategory.List),
      },
      {
        path: "/design/child-category",
        element: <ChildCategory />,
        status: isAllow?.includes(IDS.DesignChildCategory.List),
      },
      {
        path: "/designs",
        element: <Design />,
        status: isAllow?.includes(IDS.Design.List),
      },
      {
        path: "/design/create",
        element: <DesignCreate />,
        status: isAllow?.includes(IDS.Design.Add),
      },

      {
        path: "/design/edit/:id",
        element: <DesignEdit />,
        status: isAllow?.includes(IDS.Design.Edit),
      },
      {
        path: "/vendor-design/edit/:id",
        element: <VendorDesignEdit />,
        status: isAllow?.includes(IDS.Vendor_Design.Edit),
      },
      {
        path: "/design/rating-reviews",
        element: <RatingReview />,
        status: isAllow?.includes(IDS.RatingReview.List),
      },

      // {
      //   path: "/masters/payment-type",
      //   element: <PaymentType />,
      //   status: isAllow?.includes(IDS.PaymentType.List),
      // },

      // {
      //   path: "/masters/brands",
      //   element: <Brands />,
      //   status: isAllow?.includes(IDS.Brand.List),
      // },

      {
        path: "/masters/community-gallery",
        element: <Community_Gallery />,
        status: isAllow?.includes(IDS.GalleryImage.List),
      },
      {
        path: "/masters/units",
        element: <Units />,
        status: isAllow?.includes(IDS.Unit.List),
      },

      {
        path: "/measurement-category",
        element: <MeasurementCategory />,
        status: isAllow?.includes(IDS.Measurement_Category.List),
      },

      {
        path: "/measurement-field",
        element: <MeasurementField />,
        status: isAllow?.includes(IDS.Measurement_Field.List),
      },

      // {
      //   path: "/masters/reviewreason",
      //   element: <Review_Reason />,
      //   status: isAllow?.includes(IDS.Review_Reason.List),
      // },

      {
        path: "/masters/shape",
        element: <Shape />,
        status: isAllow?.includes(IDS.Shape.List),
      },

      {
        path: "/settings/location/country",
        element: <Country />,
        status: isAllow?.includes(IDS.Country.List),
      },
      {
        path: "/settings/master/time-slot",
        element: <TimeSlot />,
        status: isAllow?.includes(IDS.TimeSlot.List),
      },
      {
        path: "/settings/masters/service-radius",
        element: <Service_Radius />,
        status: isAllow?.includes(IDS.Service_Radius.List),
      },

      {
        path: "/settings/masters/suitable",
        element: <Suitable />,
        status: isAllow?.includes(IDS.Suitable.List),
      },
      {
        path: "/settings/masters/vehicle",
        element: <Vehicle />,
        status: isAllow?.includes(IDS.Vehicle.List),
      },
      {
        path: "/settings/masters/change-slot",
        element: <Change_Slot />,
        status: isAllow?.includes(IDS.Change_Slot.List),
      },
      {
        path: "/settings/masters/fabric",
        element: <Fabric />,
        status: isAllow?.includes(IDS.Fabric.List),
      },
      {
        path: "/settings/masters/occassion",
        element: <Occassion />,
        status: isAllow?.includes(IDS.Occassion.List),
      },
      {
        path: "/settings/masters/alteration-type",
        element: <Alteration_Type />,
        status: isAllow?.includes(IDS.Alteration_Type.List),
      },
      {
        path: "/settings/masters/express-delivery",
        element: <Express_Delivery />,
        status: isAllow?.includes(IDS.Express_Delivery.List),
      },
      {
        path: "/settings/location/state",
        element: <State />,
        status: isAllow?.includes(IDS.State.List),
      },
      {
        path: "/settings/location/city",
        element: <City />,
        status: isAllow?.includes(IDS.City.List),
      },
      {
        path: "/settings/location/area",
        element: <Area />,
        status: isAllow?.includes(IDS.Area.List),
      },
      {
        path: "/settings/location/pincode",
        element: <Pincode />,
        status: isAllow?.includes(IDS.Pincode.List),
      },

      {
        path: "/master/country-code",
        element: <CountryCode />,
        status: isAllow?.includes(IDS.CountryCode.List),
      },
      {
        path: "/settings/home-banner",
        element: <Homebanner />,
        status: isAllow?.includes(IDS.HomeBanner.List),
      },

      {
        path: "/settings/add-banner",
        element: <AdvertisementBanner />,
        status: isAllow?.includes(IDS.AdvertiseBanner.List),
      },
      {
        path: "/settings/faq-categories",
        element: <FaqCategory />,
        status: isAllow?.includes(IDS.FaqCategory.List),
      },
      {
        path: "/settings/faqs",
        element: <Faqs />,
        status: isAllow?.includes(IDS.Faq.List),
      },
      {
        path: "/settings/about-us",
        element: <AboutUs />,
        status: isAllow?.includes(IDS.AboutUs.List),
      },
      {
        path: "/about-us/the-essence",
        element: <TheEssence />,
        status: isAllow?.includes(IDS.TheEssence.List),
      },
      {
        path: "/about-us/how-we-work",
        element: <HowWeWork />,
        status: isAllow?.includes(IDS.HowWeWork.List),
      },
      {
        path: "/about-us/why-choose-us",
        element: <WhyChooseUs />,
        status: isAllow?.includes(IDS.WhyChooseUs.List),
      },
      {
        path: "/about-us/counter",
        element: <Counter />,
        status: isAllow?.includes(IDS.Counter.List),
      },
      {
        path: "/about-us/customer-feedback",
        element: <CustomerFeedback />,
        status: isAllow?.includes(IDS.CustomerFeedback.List),
      },
      {
        path: "/settings/terms-and-condition",
        element: <TermsAndCondition />,
        status: isAllow?.includes(IDS.TermsAndCondition.List),
      },
      {
        path: "/settings/privacy-policy",
        element: <PrivacyPolicy />,
        status: isAllow?.includes(IDS.PrivacyPolicy.List),
      },
      {
        path: "/settings/return-policy",
        element: <ReturnPolicy />,
        status: isAllow?.includes(IDS.ReturnPolicy.List),
      },
      {
        path: "/settings/help",
        element: <Help />,
        status: isAllow?.includes(IDS.Help.List),
      },
      {
        path: "/settings/social-links",
        element: <SocialLink />,
        status: isAllow?.includes(IDS.SocialLink.List),
      },
      {
        path: "/settings/app-setup",
        element: <AppSetup />,
        status: isAllow?.includes(IDS.AppSetup.List),
      },
      {
        path: "/settings/app-setup/edit/:id",
        element: <AppSetup_edit />,
        status: isAllow?.includes(IDS.AppSetup.Edit),
      },

      {
        path: "/settings/home-watch-and-shop",
        element: <HomeWatchAndShop />,
        status: isAllow?.includes(IDS.HomeWatchAndShop.List),
      },
      // {
      //   path: "/orders/all-orders",
      //   element: <Design_Orders />,
      //   status: isAllow?.includes(IDS.Order.List),
      // },
      {
        path: "/orders/all-orders",
        element: <Orders_Table />,
        status: isAllow?.includes(IDS.Order.List),
      },
      // {
      //   path: "/orders/schedule-pickup/:id",
      //   element: <SchedulePickup />,
      //   status: isAllow?.includes(IDS.Order.List),
      // },
      {
        path: "/design/ratings/:id",
        element: <Ratings />,
        status: isAllow?.includes(IDS.RatingReview.List),
      },
      {
        path: "/customers",
        element: <Customers />,
        status: isAllow?.includes(IDS.Customer.List),
      },

      {
        path: "/customers/view/:id",
        element: <Customers_view />,
        status: isAllow?.includes(IDS.Customer.List),
      },

      {
        path: "/expert",
        element: <ExpertManagement />,
        status: isAllow?.includes(IDS.Expert.List),
      },
      {
        path: "/aboutus/about-us-content",
        element: <AboutUsContent />,
        status: isAllow?.includes(IDS.AboutUsContent.List),
      },
      {
        path: "/coupons/coupon",
        element: <Coupon />,
        status: isAllow?.includes(IDS.Coupon.List),
      },
      {
        path: "/coupons/edit/:id",
        element: <Coupon_edit />,
        status: isAllow?.includes(IDS.Coupon.Edit),
      },

      {
        path: "/my-wallet",
        element: <MyWallet />,
        status: isAllow?.includes(IDS.Wallet.List),
      },
      {
        path: "/wallet/withdraw-request",
        element: <WithdrawRequest />,
        status: isAllow?.includes(IDS.WithdrawRequest.List),
      },

      {
        path: "/master/cancel-reason",
        element: <CancelReason />,
        status: isAllow?.includes(IDS.CancelReason.List),
      },
      {
        path: "/master/reject-reason",
        element: <RejectReasons />,
        status: isAllow?.includes(IDS.RejectReasons.List),
      },
      {
        path: "/master/return-reason",
        element: <ReturnReason />,
        status: isAllow?.includes(IDS.ReturnReason.List),
      },
      {
        path: "/design/offered-designs",
        element: <OfferedDesign />,
        status: isAllow?.includes(IDS.OfferedDesign.List),
      },

      {
        path: "/purchase-product/purchase-product",
        element: <PurchaseDesign />,
        status: isAllow?.includes(IDS.PurchaseDesign.List),
      },

      {
        path: "/purchase-product/edit/:id",
        element: <PurchaseDesign_edit />,
        status: isAllow?.includes(IDS.PurchaseDesign.Edit),
      },

      {
        path: "/purchase-product/compare/:id",
        element: <PurchaseDesign_compare />,
        status: isAllow?.includes(IDS.PurchaseDesign.Edit),
      },

      {
        path: "/purchase-product/receiving-order",
        element: <ReceivingOrder />,
        status: isAllow?.includes(IDS.Receiving_Order.List),
      },

      {
        path: "/purchase-product/supplier",
        element: <Supplier />,
        status: isAllow?.includes(IDS.Supplier.List),
      },

      {
        path: "/purchase-product/receiving-order/edit/:id",
        element: <ReceivingOrder_edit />,
        status: isAllow?.includes(IDS.Receiving_Order.Edit),
      },

      {
        path: "/aboutus/founding-farmers",
        element: <Founding_Farmers />,
        status: isAllow?.includes(IDS.OfferedDesign.List),
      },
      {
        path: "/aboutus/achievement",
        element: <Achievement />,
        status: isAllow?.includes(IDS.OfferedDesign.List),
      },
      {
        path: "/blog",
        element: <Blog />,
        status: isAllow?.includes(IDS.Blog.List),
      },
      {
        path: "/contact-us-form",
        element: <ContactUsForm />,
        status: isAllow?.includes(IDS.ContactUs.List),
      },

      {
        path: "/vendor-enquiry",
        element: <VendorEnquiry />,
        status: isAllow?.includes(IDS.Vendor_Enquiry.List),
      },

      {
        path: "/master/delivery-range",
        element: <DeliveryRange />,
        status: isAllow?.includes(IDS.OfferedDesign.List),
      },

      {
        path: "/masters/size",
        element: <Size />,
        status: isAllow?.includes(IDS.Size.List),
      },
      // {
      //   path: "/masters/diamond",
      //   element: <Diamond />,
      //   status: isAllow?.includes(IDS.Diamond.List),
      // },
      {
        path: "/masters/issue-types",
        element: <Issue_Types />,
        status: isAllow?.includes(IDS.Issue_Type.List),
      },

      {
        path: "/masters/metal",
        element: <Metal />,
        status: isAllow?.includes(IDS.OfferedDesign.List),
      },
      // {
      //   path: "/masters/exchange-rate",
      //   element: <Exchange_Rate />,
      //   status: isAllow?.includes(IDS.Exchange_Rate.List),
      // },

      {
        path: "/masters/customer-love",
        element: <Customer_Love />,
        status: isAllow?.includes(IDS.CustomerLove.List),
      },

      // {
      //   path: "/design/design-request",
      //   element: <DesignRequest />,
      //   status: isAllow?.includes(IDS.Design.List),
      // },
      {
        path: "/design/design-request/:id",
        element: <DesignRequestEdit />,
        status: isAllow?.includes(IDS.Design.Edit),
      },
      {
        path: "/design/design-request-create/:id",
        element: <DesignRequestAdd />,
        status: isAllow?.includes(IDS.Design.Edit),
      },
      {
        path: "/refer-history",
        element: <Refer_History />,
        status: isAllow?.includes(IDS.Refer_History.List),
      },
    ]);
  }, [isAllow]);

  // const [isLaptopView, setIsLaptopView] = useState(window.innerWidth > 991);
  // useEffect(() => {
  //   const handleResize = () => {
  //     setIsLaptopView(window.innerWidth > 991);
  //   };

  //   window.addEventListener("resize", handleResize);
  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);

  // if (!isLaptopView) {
  //   return (
  //     <div style={{ padding: "2rem", textAlign: "center" }}>
  //       <h2>Kindly open admin panel in laptop view</h2>
  //     </div>
  //   );
  // }

  return (
    <div
      className={`main ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"}`}
    >
      {isLoginPage && !signin ? (
        <Login />
      ) : isForgetPassword && !signin ? (
        <ForgetPassword />
      ) : (
        <div className=" row me-0 ms-0">
          <div
            className={`${
              isSidebarOpen
                ? "sidebarHeadopen col-xl-2 col-lg-2 col-md-1 col-1  p-0"
                : "scale-in-hor-left sidebarHeadClose col-xl-1 col-md-1 col-1  p-0"
            }  pe-0`}
          >
            <div
              className={`${
                isSidebarOpen
                  ? "sidebarHeadopen "
                  : "scale-in-hor-left sidebarHeadClose"
              }  pe-0`}
            >
              <Sidebar />
            </div>
          </div>

          <div
            className={`${
              isSidebarOpen
                ? "dashboradopen col-xl-10 col-lg-10 col-md-11 col-11 p-0"
                : "scale-in-hor-right dashboradopen  col-xl-11 col-md-11 col-11 p-0"
            }  ps-0`}
          >
            <div
              className={`${
                isSidebarOpen
                  ? "dashboradopen"
                  : "scale-in-hor-right dashboradopen"
              }  ps-0`}
            >
              <div className="allRoutesMain tab-radio">
                <Routes>
                  {urls?.map(
                    (url) =>
                      url.status && (
                        <Route path={url.path} element={url.element} />
                      ),
                  )}
                  <Route path="*" element={<PageNotFound />} />
                </Routes>
              </div>
              {/* <Home /> */}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default App;
